import { render, staticRenderFns } from "./AltaPagoCuenta.vue?vue&type=template&id=5fb2338f&scoped=true&"
import script from "./AltaPagoCuenta.vue?vue&type=script&lang=js&"
export * from "./AltaPagoCuenta.vue?vue&type=script&lang=js&"
import style0 from "./AltaPagoCuenta.vue?vue&type=style&index=0&id=5fb2338f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2338f",
  null
  
)

export default component.exports